import React, { useRef } from 'react';
import './App.scss';
import '@fortawesome/fontawesome-free/css/all.css';

import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Pages } from '~/pages';
import { Nav } from '~/components/Nav';
import { Alert } from '~/components/Alert';
import { ApiErrorListener, HistoryListener, TimeoutListener, logError } from '~/util';

import {
    AlertContext,
    ContextProviders,
    ReminderProvider,
    SearchProvider,
    ServicesContext,
} from '~/services';
import { GlobalFallback } from '~/components/Errors';

function App() {
    const mainRef = useRef(null);
    return (
        <ErrorBoundary FallbackComponent={GlobalFallback} onError={logError}>
            <Router>
                <ContextProviders mainRef={mainRef}>
                    <ServicesContext.Consumer>
                        {(services) => (
                            <>
                                <TimeoutListener services={services} />
                                <ApiErrorListener />
                            </>
                        )}
                    </ServicesContext.Consumer>
                    <AlertContext.Consumer>
                        {(alert) => <HistoryListener alert={alert} />}
                    </AlertContext.Consumer>
                    <SearchProvider>
                        <ReminderProvider>
                            <Nav />
                            <main className="py-4" ref={mainRef}>
                                <Alert />
                                <Pages />
                            </main>
                        </ReminderProvider>
                    </SearchProvider>
                </ContextProviders>
            </Router>
        </ErrorBoundary>
    );
}

export default App;
